import { Timestamp } from 'firebase/firestore';

export interface InactivityWarnings {
  warningsSent?: number;
  warningDate?: Timestamp;
  initialWarningDate?: Timestamp;
}
